'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiThumbsDown = function TiThumbsDown(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.3 8.3c-1.2 0-2.4 0.5-3.2 1.3-0.1-0.1-0.2-0.2-0.4-0.3-1.6-1.3-6.1-2.6-9.7-2.6-3.1 0-4.3 0.5-5.4 0.9-0.2 0.1-0.4 0.1-0.5 0.2-1.4 0.5-2.7 2-2.9 3.7l-1.2 9.9c-0.2 1.7 0.8 3.6 2.4 4.1 0.6 0.3 4.2 0.7 6.5 1-0.4 2.1-0.6 4-0.6 6 0 2.3 1.9 4.2 4.2 4.2s4.2-1.9 4.2-4.2c0-3.1 1.1-4.6 2.7-6.2 0.9 1.2 2.3 2 3.9 2 2.8 0 5-2.2 5-5v-10c0-2.7-2.2-5-5-5z m-10 24.2c0 0.5-0.3 0.8-0.8 0.8s-0.8-0.3-0.8-0.8c0-3 0.4-5.4 0.8-7.2l0.5-2.3-2.2 0.3c-1-0.1-6.6-0.7-7.3-0.9-0.1 0-0.2-0.3-0.1-0.5l1.1-10c0-0.4 0.4-0.9 0.7-1 0.2-0.1 0.4-0.1 0.6-0.2 0.9-0.4 1.7-0.7 4.2-0.7 3.2 0 6.9 1.3 7.7 1.9 0.3 0.2 0.6 0.9 0.6 1.4v8.3c0 0.1 0 1.1-1.1 2.2-1.6 1.5-3.9 3.8-3.9 8.7z m11.7-9.2c0 1-0.7 1.7-1.7 1.7s-1.6-0.7-1.6-1.7v-10c0-0.9 0.7-1.6 1.6-1.6s1.7 0.7 1.7 1.6v10z' })
        )
    );
};

exports.default = TiThumbsDown;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/thumbs-down.js
// module id = 2224
// module chunks = 0